import './MetamaskLargeIcon.css'
import React, { Component } from 'react'

class MetamaskLargeIcon extends Component {
  render() {
    return (
      <div className="metamask-large-icon"></div>)
  }
}
export default MetamaskLargeIcon